function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M28 4.53857H4.00004C2.53337 4.53857 1.33337 5.73857 1.33337 7.20524V25.8719C1.33337 27.3386 2.53337 28.5386 4.00004 28.5386H28C29.4667 28.5386 30.6667 27.3386 30.6667 25.8719V7.20524C30.6667 5.73857 29.4667 4.53857 28 4.53857ZM28 22.8719C28 24.5288 26.6569 25.8719 25 25.8719H7.00004C5.34319 25.8719 4.00004 24.5288 4.00004 22.8719V10.2052C4.00004 8.54838 5.34319 7.20524 7.00004 7.20524H25C26.6569 7.20524 28 8.54839 28 10.2052V22.8719ZM10.6667 20.5386C10.6667 18.3252 12.4534 16.5386 14.6667 16.5386C15.1334 16.5386 15.5867 16.6319 16 16.7786V8.53857H20C21.4728 8.53857 22.6667 9.73248 22.6667 11.2052H18.6667V20.5786C18.64 22.7652 16.8667 24.5386 14.6667 24.5386C12.4534 24.5386 10.6667 22.7519 10.6667 20.5386Z",
  fill: "#432A74"
});

var SvgStagehallDisabled = function SvgStagehallDisabled(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStagehallDisabled, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/stagehall-disabled.ea3c1205.svg";
export { ForwardRef as ReactComponent };